import { api } from '../lib/api';

export interface OfficeSensorBeehiveRow {
  id: number;
  packetId: number;
  mac: string;
  name: string | null;
  sensorType: string | null;
  rssi: number | null;
  ok: boolean;
  weightG: number | null;
  temperatureC: number | null;
  soundRaw: number | null;
  batteryV: number | null;
  observedAt: string;
  receivedAt: string;
}

export interface OfficeSensorTrafficPacket {
  id: number;
  schemaVersion: number;
  gatewayName: string | null;
  gatewayMac: string;
  gatewayBootCount: number | null;
  gatewayUptimeS: number | null;
  gatewayTimeValid: boolean | null;
  gatewayTimeSource: string | null;
  gatewayTime: string;
  powerBatteryV: number | null;
  powerBatteryPct: number | null;
  powerSolarV: number | null;
  receivedAt: string;
  beehiveCount: number;
  beehives: OfficeSensorBeehiveRow[];
}

export const officeSensorTrafficApi = {
  list: (limit = 100) => api.get<{ items: OfficeSensorTrafficPacket[] }>(`/office/sensor-traffic?limit=${encodeURIComponent(String(limit))}`),
};
